import { createSidebarItems } from "./modules/sidebarItems";
import { scrollToTop, initAnimations } from "./modules/animation";

window.addEventListener('load', () => {
  createSidebarItems();

  document.querySelector('.scroll-to-top').addEventListener('click', scrollToTop);
});

window.addEventListener('resize', () => {
});

window.onload = () => {
  initAnimations();
};
